import {
  forwardRef,
  useContext,
  type ForwardedRef,
  type HTMLAttributes,
} from 'react';
import mergeRefs from 'merge-refs';
import { Dialog } from '../../Dialog/Dialog';
import { ModalContext } from '../ModalOverlay/ModalOverlay';

type Props = {
  ariaLabel: string;
} & Omit<HTMLAttributes<HTMLDivElement>, 'aria-label'>;

export const ModalContent = forwardRef(function ModalContent(
  props: Props,
  forwardedRef: ForwardedRef<HTMLDivElement>
) {
  const { ariaLabel, children, ...divProps } = props;
  const value = useContext(ModalContext);
  if (process.env.NODE_ENV === 'development') {
    if (value === null) {
      throw new Error('Modal context value cannot be null!');
    }
  }

  const { modalProps, ref } = value as ModalContext;

  return (
    <Dialog
      {...modalProps}
      {...divProps}
      ref={mergeRefs(ref, forwardedRef)}
      ariaLabel={ariaLabel}
    >
      {children}
    </Dialog>
  );
});
